// extracted by mini-css-extract-plugin
export var numpadContainer = "_kp-1";
export var phoneButton = "_kp-0";